import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useEffect } from 'react';
import UsageTracker from '../../../utils/UsageTracker';
import { UserAttributeKeys } from '../../userAttributes';
import { useUserAttribute } from '../../userAttributes/userAttributesQueries';
import { useShowWizardLanguageToggle } from '../wizardQueries';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const WizardLanguageToggle = ({
  showMoreContentInEnglishTooltip
}) => {
  const {
    userAttribute: includeEnglish,
    setUserAttribute: setPreappliedFilter,
    unsetUserAttribute: unsetPreappliedFilter,
    userAttributeLoading
  } = useUserAttribute(UserAttributeKeys.PREAPPLIED_FILTER_CHANGED);
  const {
    languageName,
    show
  } = useShowWizardLanguageToggle();
  const onToggleLanguageFilter = useCallback(() => {
    UsageTracker.track('wizardInteraction', {
      action: 'wizard-toggle-include-english',
      completedState: !includeEnglish
    });
    if (!includeEnglish) {
      void setPreappliedFilter(true);
    } else {
      void unsetPreappliedFilter();
    }
  }, [includeEnglish, setPreappliedFilter, unsetPreappliedFilter]);
  useEffect(() => {
    if (show) {
      UsageTracker.track('wizardInteraction', {
        action: 'wizard-toggle-viewed'
      });
    }
  }, [show]);
  if (!show || userAttributeLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(Tooltip, {
      open: showMoreContentInEnglishTooltip,
      placement: "bottom",
      title: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.wizard.progresspanel.languageToggleLabelTipHeader"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.wizard.progresspanel.languageToggleLabelTipContent",
          options: {
            languageName
          }
        })]
      }),
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        justifyContent: "space-between",
        children: [/*#__PURE__*/_jsx(FormLabel, {
          htmlFor: "languageToggle",
          children: /*#__PURE__*/_jsx(Text, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "learningCenter.wizard.progresspanel.languageToggleLabel"
            })
          })
        }), /*#__PURE__*/_jsx(Toggle, {
          checked: !!includeEnglish,
          "data-test-id": "wizard-language-toggle",
          id: "languageToggle",
          onChange: onToggleLanguageFilter,
          size: "small"
        })]
      })
    })
  });
};